export default {
  "Audio Compressor": "Compressore Audio",
  "HitPaw Online Audio Compressor": "HitPaw Online Compressore Audio",
  "Reduce audio file size online without quality loss.": "Riduce le dimensioni del file audio online senza perdita di qualità.",
  "Compress": "Comprime",
  "Compressing": "Sta Comprimendo",
  "Compressed Successfully": "Compresso con successo",
  "Compress New": "Comprime un nuovo",
  "Compression is complete": "La compressione è completa",
  "Compression failed": "Compressione non riuscita",
  "Quality": "Qualità",
  "Format": "Formato",
  "Add file": "Aggiunge file",
  "Output Settings": "Impostazioni di Produzione",

};
